import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import popout_cut_svg from '../../../assets/img/SVG_icons/Top/advanced_operation/popout_cut.svg';
import { img } from '@phi/components';
import { uid_thicken } from '@frontend/ui_display';
import PopoutCutTooltip from './PopoutCutTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const PopoutCutIcon = popout_cut_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Popout Cut';
        },

        disabled() {
            return this.state.editing_reference_sketches
                || this.state.selected_faces_count === 0;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.state.selected_faces_count > 0)
                uid_thicken();
        },
    },

    render() {
        return h(BarButton, {
            disabled: this.disabled,
            selected: this.state.tut_stage === 4,
            active: false,
            id: 'popout-cut-button',
            tippy: 'bottom',
            onClick: this.onClick,
            help: 'popout_cut',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(popout_cut_svg, this.alt),
            tooltip: PopoutCutTooltip,
        });
    },
});
